import { Injectable } from '@angular/core';

import { AuthService } from '../services/auth.service';

import { ICompany } from '../models/ICompany.model';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { ICompanyContact } from '../models/ICompanyContact.model';
import { ICompanyContactLogin } from '../models/ICompanyContactLogin.model';
import { SaveCompanyContact } from '../models/SaveCompanyContact.model';
import 'rxjs/add/operator/do';
import { UserType } from '../models/User.model';

@Injectable()
export class CompanyService {
    private recruiterInfo: ICompanyContactLogin;

    constructor(
        private _auth: AuthService,
        private http: HttpClient
    ) {
        if (!localStorage.getItem('recruiter') && _auth.getImpersonationData() == null) {
            this.updateRecruiterInfo();
        }
    }

    getLoginInfo(): ICompanyContactLogin {
        return this.recruiterInfo || (this.recruiterInfo = JSON.parse(localStorage.getItem('recruiter')) as ICompanyContactLogin);
    }

    updateRecruiterInfo(): void {
        this.http.get<ICompanyContactLogin>(`${environment.portalBase}companies/get-login-info/${this._auth.getUser().Id}`)
            .subscribe(info => {
                this.recruiterInfo = info;

                localStorage.setItem('recruiter', JSON.stringify(this.recruiterInfo));
            });
    }

    recruiterGetCompanies(companyContactId): Observable<ICompany[]> {
        return this.http.get<ICompany[]>(`${environment.portalBase}companies/${companyContactId}`);
    }

    getCompanies(): Observable<ICompany[]> {
        return this.http.get<ICompany[]>(`${environment.portalBase}companies`);
    }

    getContact(companyContactId: number): Observable<ICompanyContact> {
        return this.http.get<ICompanyContact>(`${environment.portalBase}companies/get-contact/${companyContactId}`);
    }

    recruiterGetContact(companyContactId: number): Observable<ICompanyContact> {
        return this.http.get<ICompanyContact>(`${environment.portalBase}companies/recruiter-get-contact/${companyContactId}`);
    }

    saveContacts(contacts: SaveCompanyContact[]): Observable<ICompanyContact[]> {
        return this.http.put<ICompanyContact[]>(`${environment.portalBase}companies/save-contacts`, contacts);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/company.service.ts